<template>
  <div>
    <a-skeleton :loading="loading" :paragraph="{ rows: 6 }">
      <div>
        <a-form-model ref="form" :model="form" :rules="rules">
          <a-form-model-item label="Title / Tên chức vụ" prop="name">
            <a-input v-model="form.name" placeholder="Nhập tên chức vụ" />
          </a-form-model-item>

          <a-form-model-item
            has-feedback
            label="Status / Trạng thái"
            prop="status"
          >
            <a-switch
              @change="onChangePosition"
              checked-children="Active"
              :defaultChecked="checkPosition"
            />
          </a-form-model-item>
        </a-form-model>

        <a-divider orientation="left">
          Information
        </a-divider>
        <a-descriptions :column="1">
          <a-descriptions-item label="Created by / Tạo bởi">
            {{ form.author && (form.author.fullname || form.author.username) }}
          </a-descriptions-item>
          <a-descriptions-item label="Created at / Ngày tạo">
            {{ form.createdAt | formatDateHour }}
          </a-descriptions-item>
          <a-descriptions-item label="Updated at / Cập nhật lần cuối">
            {{ form.updatedAt | formatDateHour }}
          </a-descriptions-item>
        </a-descriptions>

        <div
          style="text-align: right;"
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-popconfirm
            title="Confirm action ?"
            ok-text="Delete"
            cancel-text="Close"
            @confirm="deletePosition"
          >
            <a-button
              style="margin-right: 5px; float: left;"
              icon="delete"
              :loading="loadingDelete"
              type="danger"
            >
              Delete
            </a-button>
          </a-popconfirm>

          <a-button
            @click="closeDrawerUpdatePosition"
            style="margin-right: 5px;"
          >
            Close
          </a-button>
          <a-button
            type="primary"
            @click="updatePosition"
            :loading="loadingUpdate"
          >
            Update
          </a-button>
        </div>
      </div>
    </a-skeleton>
  </div>
</template>
<script>
import getQuery from "../../data/getData";
import postQuery from "../../data/postData";
export default {
  props: {
    updatePositionOnView: {
      type: Function,
      default: null,
    },
    deletePositionOnView: {
      type: Function,
      default: null,
    },
    closeDrawerUpdatePosition: {
      type: Function,
      default: null,
    },
    idPosition: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      checkPosition: true,
      loading: true,
      loadingUpdate: false,
      loadingDelete: false,

      form: {
        name: null,
        status: null,
      },
      rules: {
        name: [
          {
            required: true,
            message: "Required / Tên chức vụ không được bỏ trống",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    onChangePosition(checked) {
      if (checked) {
        this.$set(this.form, "status", "ACTIVE");
      } else {
        this.$set(this.form, "status", "DEACTIVE");
      }
    },
    goToListPosition(index) {
      this.$router.push({
        name: "position",
      });
    },
    getPosition() {
      this.$apollo
        .query({
          query: getQuery.queryGetPosition,
          variables: {
            id: this.idPosition,
          },
        })
        .then(({ data }) => {
          if (data?.getPosition) {
            this.form = { ...data.getPosition };
            this.loading = false;
            if (this.form.status === "ACTIVE") {
              this.checkPosition = true;
            } else {
              this.checkPosition = false;
            }
          }
        })
        .catch((error) => {
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          console.log("Không lấy được chi tiết chức vụ", error);
        });
    },
    updatePosition() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingUpdate = true;
          this.$apollo
            .mutate({
              mutation: postQuery.queryUpdatePosition,
              variables: {
                name: this.form.name,
                status: this.form.status,
                id: this.idPosition,
              },
            })
            .then(({ data }) => {
              if (data?.updatePosition) {
                this.$notification.success({
                  message: "Success",
                  description: "Updated Success!",
                });

                this.closeDrawerUpdatePosition();
                this.updatePositionOnView(data.updatePosition);
              }
              this.loadingUpdate = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Error",
                description: "Updated Error!",
              });
              console.log("Không cập nhật được chức vụ", error);
              this.loadingUpdate = false;
            });
        } else {
          return false;
        }
      });
    },
    deletePosition() {
      this.loadingDelete = true;
      this.$apollo
        .mutate({
          mutation: postQuery.queryDeletePosition,
          variables: {
            id: this.idPosition,
          },
        })
        .then(({ data }) => {
          if (data?.deletePosition) {
            this.$notification.success({
              message: "Success",
              description: "Deleted Success!",
            });

            this.closeDrawerUpdatePosition();
            this.deletePositionOnView(data.deletePosition);
          }
          this.loadingDelete = false;
        })
        .catch((error) => {
          this.$notification.error({
            message: "Error",
            description: "Deleted Error!",
          });
          console.log("Xóa chức vụ không thành công", error);
          this.loadingDelete = false;
        });
    },
  },

  created() {
    this.getPosition();
  },
};
</script>
<style></style>
